<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Import Contacts</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/contacts">Contacts</router-link>
                  </li>
                  <li class="breadcrumb-item active">Import Contacts</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a target="_blank" :href="urlTemplate" class="btn add-btn">
                  <i class="fa fa-download"></i> Download Template
                </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- /Search Filter -->
          <form @submit.prevent="inputFileHandler">
            <div class="row">
              <!-- <form id="js-upload-form"> -->
              <div class="col-md-12">
                <label class="d-block">File</label>

                <div v-show="files.length == 0" class="col-md-12 upload-drop-zone" id="drop-zone">
                  <center>
                    <i class="fa fa-cloud-upload fa-2x"></i>
                    <span class="upload-text">
                      <label :for="name">
                        Just drag and
                        drop file here
                      </label>
                    </span>
                  </center>
                </div>
              </div>
              <div class="col-md-12">
                <!-- {{files}} -->
                <!-- <h4 v-if="files.length">Uploading</h4> -->
                <ul class="upload-list" v-if="files.length">
                  <li v-for="file in files" :key="file.id" class="file-list">
                    <div class="upload-wrap">
                      <div class="file-name">
                        <!-- <i class="fa fa-photo"></i> -->
                        <img style="width:30px;" v-if="file.thumb" :src="file.thumb" />
                        {{ file.name }}
                      </div>
                      <div class="file-size">{{ formatSizes(file.size) }}</div>
                      <div class="file-close">
                        <span class="text-danger" v-if="file.error">{{ file.error }}</span>
                        <span v-else-if="file.success">
                          <i class="text-success fa fa-check-circle"></i>
                        </span>
                        <span v-else-if="file.active">active</span>
                        <span v-else></span>

                        <a href="#" @click.prevent="$refs.uploadbc.remove(file)" class="text-warning">
                          <i class="fa fa-trash-o"></i>
                        </a>
                      </div>
                    </div>

                    <div class="progress progress-xs progress-striped" v-if="file.active || file.progress !== '0.00'">
                      <div class="progress-bar bg-success" role="progressbar" :style="{ width: file.progress + '%' }">
                      </div>
                    </div>
                    <div class="upload-process" v-if="file.active || file.progress !== '0.00'">{{ file.progress }}% done
                    </div>
                  </li>
                </ul>
              </div>
              <!-- </form> -->

              <div class="col-sm-12 col-md-12">
                <div class="alert alert-warning">
                  <ul>
                    <li>Support files: {{ extensions }}</li>
                    <li>MaxSize: 10Mb</li>
                    <li>Maksimal 5000 Data per 1x import</li>
                    <li>Nama sheet harus <b>Sheet1</b></li>
                    <li class="text text-danger">
                      Isi nomor whatsapp dengan format kode negara dan tanpa spasi.
                      <br />Misal: 6281234567890
                    </li>
                    <li>Kolom ulang tahun tidak wajib diisi. Tetapi jika ingin diisi, formatnya wajib YYYY-MM-DD. 
                      <br />Misal: 2024-12-31
                    </li>

                  </ul>
                </div>
              </div>
              <div class="col-sm-12" v-show="($refs.uploadbc && $refs.uploadbc.active == false)">
                <div class="submit-section">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend" v-show="false">
                      <file-upload :add-index="true" class="btn btn-outline-secondary" :data="objFilesMessageHandler"
                        :post-action="uploadUrl" :multiple="false" :headers="headers" :drop="true"
                        :drop-directory="true" v-model="files" @input-filter="inputFilter" @input-file="inputFile"
                        ref="uploadbc" :maximum="maximumUpload" :extensions="extensions">
                        <img src="@/assets/attachment.png" alt />
                      </file-upload>
                    </div>

                    <div class="input-group-append">
                      <button v-if="false" @click.prevent="$refs.uploadbc.active = true"
                        class="btn btn-outline-secondary" type="button">Upload File</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="$refs.uploadbc && $refs.uploadbc.active == true">
                <div class="col-sm-2">
                  <Skeleton :height="'40px'" :count="1" />
                </div>
                <div class="col-sm-2">
                  <Skeleton :height="'40px'" :count="1" />
                </div>
                <div class="col-sm-6">
                  <Skeleton :height="'40px'" :count="1" />
                </div>
                <div class="col-sm-2">
                  <Skeleton :height="'40px'" :count="1" />
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-6 col-sm-12 col-12">
                <div class="form-group">  
                  <label class="d-block">Group</label>
                  <div class="task-wrapper">
                    <div class="task-list-container">
                      <div class="task-list-body">
                        <a href="#" class="btn btn-primary btn-block" data-toggle="modal" data-target="#add_group">
                          <i class="fa fa-plus"></i> Add a new group
                        </a>
                        <div class="input-group ">
                          <span class="input-group-text" id="basic-addon1"><i class="fa fa-search"></i></span>
                          <input v-model="filter" type="text" class="form-control" placeholder="Group Name"
                            aria-label="Group Name" aria-describedby="basic-addon1">
                        </div>
                        <ul id="task-list">
                          <template v-for="rowG in groupListFilterArr">
                            <template>
                              <li v-on:click="selectGroup(rowG.id);" v-bind:id="rowG.id" class="task" :class="{
                                'completed': formContact.list_id.includes
                                  (rowG.id)
                              }" :key="rowG.id">
                                <div class="task-container">
                                  <span class="task-action-btn task-check">
                                    <span class="action-circle large complete-btn" title="Select">
                                      <i class="material-icons">check</i>
                                    </span>
                                  </span>
                                  <span class="task-label" contenteditable="false">{{ rowG.name }}</span>
                                </div>
                              </li>
                            </template>
                          </template>
                        </ul>
                        <strong><small v-if="formContact.list_id.length">Group Selected : {{ formContact.list_id.length }}</small></strong>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button :disabled="!files.length" @click.prevent="inputFileHandler"
                    class="btn btn-primary submit-btn">Upload</button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
    <create-group :getGroupList="getGroupList" />
  </div>
</template>

<script>
import { formatDate, formatSizes } from "@/utils/helper";
import CreateGroup from "./createGroup.vue";

import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    FileUpload,
    CreateGroup
  },
  data() {
    return {
      urlTemplate: process.env.VUE_APP_IC_URL,
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        list_id: []
      },
      loadingGroup: false,
      name: "file",
      thumbUpload: [],
      filter: '',
      uploadAuto: false,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICore() +
        "/contact/import-contact",
      maximumUpload: 1,
      accept: "image/png,image/gif,image/jpeg,image/webp",
      extensions: "xlsx",
      minSize: 1024,
      size: 1024 * 1024 * 10,
      files: [],
      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000
      },
      formContact: {
        file: null,
        list_id: []
      },
      loading: false
    };
    //  isactive : true
  },
  created() {
    this.getGroupList();
    this.$root.$on("getGroupList", dataParams => {
      this.getGroupList(dataParams);
    }); 
  },
  beforeDestroy() {
    this.$root.$off("getGroupList");
  },
  filters: {
    labelPackageProduct(value) {
      return labelPackageProduct(value);
    }
  },
  computed: {
    groupListArr() {
      return this.$store.state.contact.groupListArr;
    },
    groupListFilterArr() {
      // Jika input pencarian kosong, tampilkan semua item
      if (!this.filter.trim()) {
        return this.groupListArr;
      }
      // Jika tidak, filter item berdasarkan pencarian
      return this.groupListArr.filter(item => {
        // Menggunakan metode 'LIKE' untuk pencarian yang mirip
        return item.name.toLowerCase().includes(this.filter.toLowerCase());
      });
    },
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken()
      };
    }
  },
  methods: {
    inputFileHandler() {
      this.$refs.uploadbc.active = true;
    },
    inputFilter(newFile, oldFile, prevent) {
      // console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }

        // var liContainer = document.getElementById("drag_files");
        // var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal",isShowModal)
        // if (isShowModal == false) {
        //   // document.getElementById("btnDragFiles").click(); // Click on the checkbox
        // }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512
          });
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type
              });
            })
            .catch(err => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress"
              });
            });
        }
      }
      // console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width
          });
        };
        img.οnerrοr = e => {
          // console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        // console.log("oldddd", oldFile);
        // console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            list_id: this.formContact.list_id
          };
          // console.log("dataarr", dataArr);
          // console.log("dataarr", this.formContact.list_id);
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          console.log("err", newFile.error.response);
          console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000
          }).then(r => { });
        }
        if (newFile.success && !oldFile.success) {
          this.thumbUpload.push(newFile.thumb);
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          // console.log("success", newFile.success, newFile);
          this.$fire({
            title: "Processing",
            text: newFile.response.msg,
            type: "warning",
            timer: 5000
          }).then(r => {
            this.$router.push("/contacts");
          });

          this.$refs.uploadbc.remove(newFile);
          this.formContact.list_id = [];
        }
      }
      if (!newFile && oldFile) {
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    },
    async getGroupList() {
      this.loadingGroup = await false;
      await this.$store
        .dispatch("contact/getGroupList", this.groupListParam) // sesuai kan dengan method di API
        .catch(error => {
          //   this.loading = false;
          this.loadingGroup = false;

          console.log("error", error);
        });
    },
    async selectGroup(id) {
      var element = document.getElementById(id);
      if (this.formContact.list_id.length > 0) {
        var isFound = false;
        var indexFound = -1;
        await this.formContact.list_id.forEach((value, index) => {
          if (value === id) {
            indexFound = index;
          }
        });

        if (indexFound >= 0) {
          element.classList.remove("completed");
          this.formContact.list_id.splice(indexFound, 1);
        } else {
          // this.$refs
          element.classList.add("completed");
          this.formContact.list_id.push(id);
        }
      } else {
        element.classList.add("completed");
        this.formContact.list_id.push(id);
      }
      // console.log("seeleee", this.formContact.list_id);
    }
  },
  mounted() {
    // Date Time Picker
    setTimeout(() => {
       if(this.$route.query.group_id){
      let found = this.groupListArr.find(element => element.id == this.$route.query.group_id);
      if(found){
        this.selectGroup(found.id);
      }
    }
    }, 2000);
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "summary_"
};
</script>


// WEBPACK FOOTER //
// src/views/contacts/import-contact.vue